var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDndPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0015 53.999C44.4773 53.999 55.4015 43.2539 55.4015 29.999C55.4015 16.7442 44.4773 5.99902 31.0015 5.99902C17.5258 5.99902 6.60156 16.7442 6.60156 29.999C6.60156 43.2539 17.5258 53.999 31.0015 53.999ZM34.0515 20.999C34.0515 19.3422 32.686 17.999 31.0015 17.999C29.3171 17.999 27.9515 19.3422 27.9515 20.999V26.999H21.8516C20.1671 26.999 18.8016 28.3422 18.8016 29.999C18.8016 31.6559 20.1671 32.999 21.8516 32.999H27.9515V38.999C27.9515 40.6559 29.3171 41.999 31.0015 41.999C32.686 41.999 34.0515 40.6559 34.0515 38.999V32.999H40.1515C41.836 32.999 43.2015 31.6559 43.2015 29.999C43.2015 28.3422 41.836 26.999 40.1515 26.999H34.0515V20.999Z",
    fill: "#310048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDndPlus);
export default __webpack_public_path__ + "static/media/dnd_plus.2b8fe18a5723394c246b012aed6aa14a.svg";
export { ForwardRef as ReactComponent };